export default __webpack_public_path__ + "static/media/github.1ba3cd4d.svg";